angular.module('aprima-legacy-common').factory('HttpAbortableContext', ['$q', '$qHelpers', '_', function($q, $qHelpers, _) {
    'use strict';
    
    return HttpAbortableContext;

    function HttpAbortableContext(previousPromiseToAbort) {
        var abortDeferred = $q.defer();
        var abortPromise = abortDeferred.promise;

        return {
            abortPromise: abortPromise,
            wrap: function wrap(promise) {
                var abortedError;
                promise = promise.catch(function(error) {
                    if(abortedError && error && error.status < 0) {
                        _.assign(error, abortedError);
                    }
                    return $q.reject(error);
                });

                return $qHelpers.abortablePromise(promise, previousPromiseToAbort, function(error) {
                    abortedError = error;
                    abortDeferred.resolve();
                    return false;
                });
            }
        };
    }
}]);
